var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exchange md-layout md-layout-item md-size-80" },
    [
      _vm.loadComplete && _vm.currentToken.length
        ? [
            _c("exchange-portfolio", {
              staticClass: "md-layout-item",
              attrs: {
                currentAsset: _vm.currentToken,
                convertAsset: _vm.convertOpts.convertAsset,
                convertedAmount: _vm.convertOpts.convertedAmount
              },
              on: { "asset-change": _vm.setCurrentAsset }
            }),
            _vm._v(" "),
            _c("exchange-rates", {
              staticClass: "md-layout-item",
              attrs: { currentAsset: _vm.currentToken }
            })
          ]
        : [
            _c("div", { staticClass: "app__no-data-msg" }, [
              _c("h3", [_vm._v(_vm._s(_vm.i18n.lbl_loading()))])
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76185e50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76185e50","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/exchange/index/Exchange.Index.vue
// module id = wnWh
// module chunks = 1